module.exports = __webpack_public_path__ + "img/license.4211deb0.svg";